<div class="parent">
  <div class="bg bg-{{ getColor() }}" [style.width]="getPercentage() + '%'"></div>
  <div class="inner">
    {{ elapsed }} of {{ total }} {{ units }}
  </div>
</div>
